module.exports = __webpack_public_path__ + "img/img47.63b643fe.png";